var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('h2',[_vm._v(" Edit Lists ")]),_c('b-list-group',_vm._l((_vm.lists),function(list){return _c('b-list-group-item',{key:list.key},[_c('b-link',{attrs:{"to":'/admin/lists/' + list.key}},[_vm._v(_vm._s(list.name))])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }